/* eslint-disable no-param-reassign */
import Sonda from "@gcloud-npm/bit.utils.front-sonda";
import { createSondaContext } from "./contextUtils";

const BenefitsFilePath = "utils/soluciones";
const sondaContextTitle = "empresas";

/**
 * Asegura que los precios con parte decimal tenga el formato correcto (separados por '.')
 * @param {String} pvp precio recibido
 * @returns {String} Precio formateado
 */
const fixPVP = (pvp) => {
  const precio = pvp.split(",");
  if (precio.length > 1) {
    return `${precio[0]}.${precio[1]}`;
  }
  return pvp;
};

/**
 * Asegura que las imagenes tengan el formato correcto (ruta absoluta)
 * @param {String} url url recibida
 * @returns {String} url formateada
 */
const fixUrl = (url) => {
  if (url === "") {
    return url;
  }
  if (!url.includes("://")) {
    return `https://www.movistar.es${url}`;
  }
  return url;
};

/**
 * Función que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de Subheader
 * @returns
 * Devuelve la informacion para el módulo de Subheader
 */
export const moduloCabeceras = (fields) => {
  try {
    const newFields = {};
    const portadas = fields["Listado de portadas"].map((item) => {
      const portada = {
        title: item.fields.title,
        alias: item.alias,
        icon: "",
        link: item.fields.url.replace("/empresas", ""),
      };
      return portada;
    });
    if (Object.keys(portadas).length > 0) {
      newFields.portadas = portadas;
      return newFields;
    }
    return null;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloCabeceras",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Función que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de Título
 * @returns
 * Devuelve la informacion para el módulo de Título
 */
export const moduloTitle = (fields) => {
  try {
    const newFields = {
      components: {
        titulo: {
          align: "center",
          color: "grey8",
          kind: "paragraph",
          size: "title04",
          fontType: "font-regular",
          text: fields.title || "",
          segment: "emp",
        },
        subtitulo: {
          align: "center",
          color: "grey5",
          kind: "paragraph",
          size: "title06",
          fontType: "font-regular",
          text: fields.subTitle || "",
          segment: "emp",
        },
      },
    };

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloTitle",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Función que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de Título
 * @returns
 * Devuelve la informacion para el módulo de Título
 */
export const moduloHeadingTitle = (fields) => {
  try {
    const newFields = {
      components: {
        TextInfo: {
          align: "center",
          color: "grey8",
          kind: "heading",
          level: 1,
          size: "title02",
          fontType: "font-regular",
          text: fields.h2Title || "",
          segment: "emp",
          tabletProps: {
            size: "title02",
          },
          desktopProps: {
            size: "title02",
          },
        },
      },
    };

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloH1Title",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de VideoBanner
 * @returns
 * Devuelve la informacion para el módulo de VideoBanner
 */
export const moduloVideoBannerFondosEuropeos = (fields) => {
  try {
    const newFields = {
      "TextInfo-1": {
        kind: "paragraph",
        size: "caption02",
        fontType: "font-light",
        color: "white",
        segment: "emp",
        tabletProps: {
          size: "caption02",
        },
        desktopProps: {
          size: "caption02",
          text: "Ver vídeo",
        },
      },
      "TextInfo-2": {
        kind: "paragraph",
        size: "title02",
        fontType: "font-light",
        color: "white",
        text: fields.claim,
        segment: "emp",
        tabletProps: {
          size: "title02",
        },
        desktopProps: {
          size: "display02",
        },
      },
      "TextInfo-3": {
        kind: "paragraph",
        size: "title06",
        fontType: "font-thin",
        color: "white",
        text: fields.subClaim,
        segment: "emp",
        tabletProps: {
          size: "title045",
        },
      },
      "TextInfo-4": {
        kind: "paragraph",
        size: "caption02",
        fontType: "font-light",
        color: "white",
        segment: "emp",
        text: fields.timeDuration || "",
      },
      bucleVideo: fields.bucleVideo,
      urlVideo: fields.urlVideo,
    };

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloVideoBanner",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Función que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo Section Image
 * @returns
 * Devuelve la información para el módulo de Section Image
 */
export const moduloSectionImage = (fields) => {
  try {
    const newFields = {
      components: {
        image: {
          src:
            fields.imgDesktop !== ""
              ? `https://www.movistar.es${fields.imgDesktop}`
              : "https://www.movistar.es/estaticos/empresas/nuevo-empresas/imagen-modulo-como-gestionarlo.png",
          alt: fields.alt || fields.title || "Imagen",
        },
        "TextInfo-1": {
          color: "blue",
          kind: "heading",
          level: 2,
          size: "title05",
          fontType: "font-regular",
          text: fields.title || "",
          segment: "emp",
          align: "center",
          tabletProps: {
            size: "title03",
            align: "left",
          },
          desktopProps: {
            size: "title03",
          },
        },
        "TextInfo-2": {
          kind: "paragraph",
          color: "grey6",
          fontType: "font-regular",
          size: "title06",
          segment: "emp",
          text: fields.description || "",
          align: "left",
          tabletProps: {
            size: "title05",
            align: "left",
          },
          desktopProps: {
            size: "title05",
          },
        },
        Button: fields.buttonLink &&
          fields.buttonText && {
            segment: "emp",
            buttonType: "button",
            font: "regular",
            border: "no-border-radius",
            textTransform: "initial",
            size: { h: "large", w: "full" },
            tabletProps: { size: { h: "large", w: "double" } },
            link: fields.buttonLink,
            label: fields.buttonText,
            color: "blue",
          },
        imagePosition: fields.align === "left" ? "right" : "left",
        desktopImageHeight: fields.desktopImageHeight || "center",
        skipPaddingTop: fields.skipPaddingTop || false,
      },
    };
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloSectionImage",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de ventajas
 * @returns
 * Devuelve la informacion para el módulo de ventajas
 */
export const moduloVentajasSolucionesDigitales = (fields) => {
  try {
    const newFields = {
      components: [],
      backgroundImg: `https://www.movistar.es${fields.backgroundImg}`,
      title: {
        text: fields.title || "Beneficios digitalización",
        color: "white",
        kind: "heading",
        level: 2,
        size: "title03",
        fontType: "font-regular",
        segment: "emp",
        align: "center",
        tabletProps: {
          align: "left",
        },
        desktopProps: {
          align: "left",
        },
      },
    };

    const listItems = fields.ventajas.reduce((arr, item) => {
      const components = {
        title: {
          text:
            item.fields.title.indexOf("<br>") === -1
              ? item.fields.title.replace(/\s/g, " <br>")
              : item.fields.title,
          color: "white",
          kind: "heading",
          level: 3,
          size: "title05",
          fontType: "font-regular",
          segment: "emp",
          align: "center",
        },
        text: {
          text: item.fields.subTitle,
          color: "white",
          kind: "paragraph",
          size: "title06",
          fontType: "font-regular",
          segment: "emp",
          align: "center",
        },
        icon: item.fields.icon,
      };
      arr = [...arr, components];
      return arr;
    }, []);

    newFields.components = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloVentajasSolucionesDigitales",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo banner
 * @returns
 * Devuelve la informacion para el módulo del banner
 */
export const moduloBannerHablaConExperto = (fields, tema) => {
  try {
    const newFields = {
      tema,
      tipoEmpresa: fields.tipoEmpresa || "empresa",
      components: {
        "BgImage-1": {
          bgColor: "black",
          div2Fit: "full",
          picDesktop: {
            position: "center",
            size: "cover",
            src:
              (fields.imgDesktop &&
                `https://www.movistar.es${fields.imgDesktop}`) ||
              "",
            shadeLimit: false,
            alt: fields.alt || fields.title,
          },
          picTablet: {
            position: "top",
            size: "cover",
            src:
              (fields.imgTablet &&
                `https://www.movistar.es${fields.imgTablet}`) ||
              (fields.imgDesktop &&
                `https://www.movistar.es${fields.imgDesktop}`) ||
              "",
            shadeLimit: false,
            alt: fields.alt || fields.title,
          },
          picMobile: {
            position: "center",
            size: "cover",
            src:
              (fields.imgMobile &&
                `https://www.movistar.es${fields.imgMobile}`) ||
              "",
            shadeLimit: false,
            alt: fields.alt || fields.title,
          },
        },
        "TextInfo-1": {
          align: "center",
          color: tema === "blue" ? "blue" : "white",
          kind: "span",
          size: "title05",
          fontType: "font-regular",
          text: fields.title,
          segment: "emp",
          tabletProps: {
            size: "title03",
            align: "left",
            fontType: "font-regular",
          },
          desktopProps: {
            size: "title03",
          },
        },
        "TextInfo-2": {
          align: "center",
          kind: "paragraph",
          color: tema === "blue" ? "blue" : "white",
          fontType: "font-regular",
          size: "title06",
          segment: "emp",
          text: fields.description,
          tabletProps: {
            size: "title05",
            align: "left",
          },
          desktopProps: {
            size: "title05",
          },
        },
        "Button-1": {
          label: fields.buttonText,

          buttonType: "button",

          color: tema === "blue" ? "blue" : "white_blue",
          size: {
            h: "large",
            w: "full",
          },
          labelSize: "medium",
          font: "regular",
          border: "no-border-radius",
          tabletProps: {
            size: {
              h: "large",
              w: "double",
            },
          },
          segment: "emp",
        },
        C2CEmpProps: [
          {
            porcentaje: "88",
            destino: "Gevico",
            tes: "SI",
            tipoTes: "FONGEV_B",
          },
          {
            porcentaje: "12",
            destino: "InsideSales",
            tes: "SI",
            tipoTes: "FONINS_B",
          },
        ],
      },
      // otracosa: {
      //   backgroundImg: (fields.imgDesktop && `https://www.movistar.es${fields.imgDesktop}`) || '',
      //   backgroundColor: fields.backgroundColor || '',
      //   'TextInfo-1': {
      //     text: fields.claim,
      //     color: 'white',
      //     kind: 'heading',
      //     level: 1,
      //     size: 'title04',
      //     fontType: 'font-light',
      //     align: 'left',
      //     segment: 'emp',
      //     tabletProps: {
      //       size: 'display02',
      //       align: 'center',
      //     },
      //     desktopProps: {
      //       size: 'display02',
      //       align: 'center',
      //     },
      //   },
      //   'TextInfo-2': {
      //     text: fields.subClaim,
      //     color: 'white',
      //     kind: 'paragraph',
      //     size: 'caption01',
      //     fontType: 'font-light',
      //     align: 'left',
      //     segment: 'emp',
      //     tabletProps: {
      //       size: 'title045',
      //       align: 'center',
      //     },
      //     desktopProps: {
      //       size: 'title045',
      //       align: 'center',
      //     },
      //   },
      // },
    };
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "móduloBannerHablaConExperto",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/** @param {*} fields Información del módulo del wrapper de imágenes
 * @returns
 * Devuelve la informacion para el módulo wrapper de imágenes
 */

export const moduloImageCircle = (fields) => {
  try {
    const newFields = fields.fields.title
      ? {
          textInfo1: {
            text: fields.fields.title || "",
            color: "blue",
            kind: "heading",
            level: 2,
            size: "title04",
            className: "threeStepsWrapperTitle",
            fontType: "font-light",
            segment: "emp",
            align: "center",
            tabletProps: {
              size: "title03",
              align: "left",
            },
            desktopProps: {
              size: "title03",
              align: "left",
            },
          },
          tipoEmpresa: fields.fields.tipoEmpresa || "",
          components: [],
        }
      : { components: [] };

    const listItems = fields.fields.soluciones.reduce((arr, item) => {
      const components = {
        title: {
          kind: "heading",
          level: 2,
          align: "center",
          size: "title04",
          fontType: "font-regular",
          color: "blue",
          text: item.fields.title || "",
          segment: "emp",
        },
        text: {
          kind: "paragraph",
          align: "center",
          size: "title05",
          fontType: "font-regular",
          color: "black",
          text: item.fields.description || "",
          segment: "emp",
        },
        image:
          (item.fields.urlImg &&
            `https://www.movistar.es${item.fields.urlImg}`) ||
          "",
        link:
          (item.fields.urlFicha &&
            `https://www.movistar.es${item.fields.urlFicha}`) ||
          "https://www.movistar.es",
        alt: item.fields.alt || item.fields.title,
      };
      arr = [...arr, components];
      return arr;
    }, []);

    newFields.components = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloSolucionesSolucionesDigitales",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/** @param {*} fields Información del módulo del wrapper de imágenes
 * @returns
 * Devuelve la informacion para el módulo wrapper de imágenes
 */

export const moduloFourKeys = (fields) => {
  try {
    const newFields = fields.fields.title
      ? {
          title: {
            text: fields.fields.title || "",
            bgColor: fields.fields.backgroundColor || "",
            color: "blue",
            kind: "heading",
            level: 2,
            size: "title04",
            fontType: "font-regular",
            segment: "emp",
            align: "center",
            tabletProps: {
              size: "title03",
              align: "center",
            },
            desktopProps: {
              size: "title03",
              align: "left",
            },
          },
          advantages: [],
        }
      : { advantages: [] };

    const listItems = fields.fields.claves.reduce((arr, item) => {
      const advantages = {
        title: {
          color: "blue",
          kind: "heading",
          level: 3,
          size: "title04",
          fontType: "font-regular",
          text: item.fields.title,
          segment: "emp",
          align: "center",
          tabletProps: {
            align: "left",
          },
        },
        text: {
          color: "grey7",
          kind: "paragraph",
          size: "title06",
          fontType: "font-regular",
          text: item.fields.description,
          segment: "emp",
          align: "center",
          tabletProps: {
            align: "left",
            size: "title05",
          },
        },
        principalPhoto: fixUrl(item.fields.urlImg) || "",
        separatorPhoto: fixUrl(item.fields.urlImg2) || "",
        photoAlt: item.fields.alt || item.fields.title,
      };
      arr = [...arr, advantages];
      return arr;
    }, []);

    newFields.advantages = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloSolucionesSolucionesDigitales",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de frase destacada
 * @returns
 * Devuelve la informacion para el módulo de frase destacada
 */
export const moduloFraseDestacada = (fields) => {
  if (fields.soluciones && fields.soluciones[0].fields) {
    const phraseItem = fields.soluciones[0].fields;
    try {
      const newFields = {
        components: {
          "TextInfo-1": {
            text: phraseItem.description || "",
            color: phraseItem.colorDescription || "grey6",
            kind: "paragraph",
            size: "title03",
            fontType: "font-regular",
            segment: "emp",
            align: "center",
          },

          "TextInfo-2": phraseItem.titleAuthor && {
            color: phraseItem.colorTitleAuthor || "grey6",
            kind: "paragraph",
            size: "title06",
            fontType: "font-regular",
            text: phraseItem.titleAuthor || "",
            segment: "emp",
            align: "center",
          },

          "Button-1": phraseItem.buttonLink &&
            phraseItem.buttonText && {
              segment: "emp",
              label: phraseItem.buttonText,
              buttonType: "button",
              taggingInfo: {
                componentName: "FeaturedPhrase",
                componentProduct: "",
                componentContent: "interes",
                componentVariation: "all",
              },
              font: "regular",
              link: phraseItem.buttonLink,
              color: "white_blue",
              size: {
                h: "large",
                w: "full",
              },
              labelSize: "medium",
              border: "no-border-radius",
              textTransform: "initial",
              tabletProps: {
                size: {
                  w: "medium",
                },
              },
              desktopProps: {
                size: {
                  w: "medium",
                },
              },
            },
        },
        backgroundImg:
          fixUrl(fields.soluciones[0].fields.urlImg) ||
          "https://www.movistar.es/estaticos/empresas/nuevo-empresas/FD-TESTIMONIAL.jpg",
        titleImage:
          fields.soluciones[0].fields.title &&
          fields.soluciones[0].fields.title.includes("/") &&
          fixUrl(fields.soluciones[0].fields.title),
      };

      return newFields;
    } catch (error) {
      const context = createSondaContext(sondaContextTitle);
      const sonda = new Sonda({
        processName: "moduloFraseDestacada",
        context,
        filePath: BenefitsFilePath,
      });
      sonda.errorMessage({ error });
      return null;
    }
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de porcentajes
 * @returns
 * Devuelve la informacion para el módulo de porcentajes
 */
export const moduloPorcentajes = (fields) => {
  const newFields = {
    components: [],
  };
  try {
    fields.resultados.map((item) => {
      const percentajeItem = {
        "TextInfo-1": {
          text: Number(item.fields.claim),
          kind: "span",
          color: "turquoise-light",
          fontType: "font-light",
          size: "display01",
          segment: "emp",
          align: "center",
        },
        "TextInfo-2": {
          kind: "paragraph",
          color: "white",
          fontType: "font-light",
          size: "title045",
          segment: "emp",
          text: item.fields.subClaim,
          align: "center",
          tabletProps: {
            size: "title04",
          },
          desktopProps: {
            size: "title04",
          },
        },
      };
      newFields.components.push(percentajeItem);
    });

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloPorcentajes",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de FAQ
 * @returns
 * Devuelve la informacion para el módulo de FAQ
 */
export const moduloFAQ = (fields) => {
  const newFields = {
    questions: [],
    title: fields.fields.title,
    titleOptions: {
      align: "center",
      fontType: "font-light",
      size: "title03",
      color: "blue-dark",
      segment: "emp",
      level: 2,
    },
    faqItemOptions: {
      default: {
        color: {
          title: "blue",
          text: "blue",
          icon: "blue",
        },
      },
      activated: {
        color: {
          text: "blue",
          icon: "blue",
        },
      },
    },
    variant: "DEFAULT",
    segment: "emp",
  };
  try {
    fields.fields.listadoFAQS.map((item) => {
      const questionItem = {
        title: item.fields.title,
        content: item.fields.description,
      };
      newFields.questions.push(questionItem);
    });

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloFAQ",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de 10 necesidades
 * @returns
 * Devuelve la informacion para el módulo de 10 necesidades
 */
export const moduloDiezNecesidades = (fields) => {
  const title = fields.fields;
  const item = fields.fields.listadonecesidadesglobal.fields;
  try {
    const newFields = {
      components: [],
      title: {
        title: {
          color: "blue",
          kind: "paragraph",
          size: "title03",
          fontType: "font-regular",
          text: title.title,
          segment: "emp",
          align: "left",
        },
        description: {
          color: "grey6",
          kind: "paragraph",
          size: "title05",
          fontType: "font-regular",
          text: title.subTitle,
          segment: "emp",
          align: "left",
        },
      },
      subTitle: {
        color: "grey6",
        kind: "paragraph",
        size: "title03",
        fontType: "font-regular",
        text: item.titleList,
        segment: "emp",
        align: "center",
        tabletProps: {
          align: "left",
        },
        desktopProps: {
          align: "left",
        },
      },
    };

    const listItems = item.familiaNecesidades.map((section) => {
      const solucionesdigitales = [];
      const sectionItem = {
        fields: {
          h2flyout: section.fields.title,
          icono: section.fields.icono,
          title: section.shortTitle || section.fields.title, // ES PARA EL SELECTOR DE RESPONSIVE
          solucionesdigitales: [],
        },
      };
      section.fields.listadoNecesidades.map((need) => {
        const needItem = {
          fields: {
            imagenDesktop: need.fields.imgDesktop,
            featuredPhrase: need.fields.flyOutmasinfo.fields.fraseDestacada,
            backgroundPrase: "",
            title: need.fields.flyOutmasinfo.fields.subtitle,
            cardTitle: need.fields.title,
            info: [need.fields.flyOutmasinfo.fields.description],
            callYouButtonText: "Te asesoramos",
            callMeBackSE: {
              activateOutHour: false,
              multipleOptions: [
                {
                  porcentaje: "88",
                  destino: "Gevico",
                  tes: "SI",
                  tipoTes: "FONGEV_B",
                },
                {
                  porcentaje: "12",
                  destino: "InsideSales",
                  tes: "SI",
                  tipoTes: "FONINS_B",
                },
              ],
            },
            flyoutTitle: need.fields.flyOutmasinfo.fields.title,
          },
        };
        solucionesdigitales.push(needItem);
      });
      sectionItem.fields.solucionesdigitales = solucionesdigitales;
      newFields.components.push(sectionItem);
    });

    // newFields.components = listItems;
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloVentajasSolucionesDigitales",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el modulo
 * @param {*} fields Información del modulo Descargas
 * @returns
 * Devuelve la informacion para el modulo Descargas
 */
export const moduloDescargas = (fields) => {
  try {
    const tipoEmpresa = fields.tipoEmpresa || "empresa";
    const itemsProdDescList = fields["Listado Productos Descarga"].reduce(
      (arr, item) => {
        const listCategories = item.fields["Listado Productos"][0].fields[
          "Listado categorias"
        ].reduce((arr2, item2) => {
          const listDocumentos = item2.fields["Listado de documentos"].reduce(
            (arr3, item3) => {
              const info = {
                title: item3.fields.title,
                urlDescarga: item3.fields.urlDescarga,
                icono: item3.fields.icono,
              };
              arr3 = [...arr3, info];
              return arr3;
            },
            []
          );
          const info2 = {
            title: item2.fields.Categoria,
            listDocumentos,
          };
          arr2 = [...arr2, info2];
          return arr2;
        }, []);
        const info = {
          title: item.fields.title,
          subTitle: item.fields.subTitle,
          listCategories,
        };
        arr = [...arr, info];
        return arr;
      },
      []
    );
    const items = { itemsProdDescList, tipoEmpresa };
    return items;

    /*
    const itemsList = fields['Listado de Documentos'].reduce((arr, item) => {
      const info = {
        title: item.fields.title,
        urlDescarga: item.fields.urlDescarga,
        icono: item.fields.icono,
      };
      arr = [...arr, info];
      return arr;
    }, [])
    const items = { itemsList };
    return items;
    */
  } catch (error) {
    const context = createSondaContext("empresas");
    const sonda = new Sonda({
      processName: "moduloDescarga",
      context,
      filePath: "utils/soluciones",
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Función que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de Categorias
 * @returns
 * Devuelve la informacion para el módulo de Categorias
 */
export const modulocategorias = (fields) => {
  try {
    const newFields = {
      segment: "emp",
      layout: fields.layout,
      tipoEmpresa: fields.tipoEmpresa || "empresa",
      components: {
        "TextInfo-1": {
          color: "blue",
          kind: "heading",
          fontType: "font-regular",
          align: "left",
          level: 2,
          size: "title01",
          text: fields.title,
        },
        "TextInfo-2": {
          color: "grey6",
          kind: "paragraph",
          fontType: "font-regular",
          align: "left",
          size: "title05",
          text: fields.subtitle,
        },
      },
    };

    const items = {};
    fields.MODULO_CATEGORIA.map((item, index) => {
      items[`categorie-${index}`] = {
        title: {
          color: fields.layout === "dark" ? "white" : "blue",
          kind: "heading",
          fontType: "font-light",
          align: "left",
          level: 3,
          size: "title04",
          text: item.fields.title,
        },
        subtitle: {
          color: fields.layout === "dark" ? "white" : "grey9",
          kind: "paragraph",
          fontType: "font-light",
          align: "left",
          size: "title06",
          text: item.fields.shortTitle,
        },
        image: {
          src: `https://www.movistar.es/${item.fields.imgDesktop}`,
          alt: item.fields.alt || item.fields.title,
        },
        unitPrice: {
          color: fields.layout === "dark" ? "white" : "grey5",
          kind: "paragraph",
          fontType: "font-light",
          align: "left",
          size: "title06",
          text: item.fields.unitPrice,
        },
        priceText: {
          color: fields.layout === "dark" ? "white" : "grey5",
          kind: "paragraph",
          fontType: "font-light",
          align: "left",
          size: "title06",
          text: item.fields.textPrice,
        },
        price: {
          amount: fixPVP(item.fields.pvp),
          unity: item.fields.unidad,
          color: fields.layout === "dark" ? "white" : "grey7",
          size: "emp-28",
          decoration: "none",
          withSpace: false,
          fontType: "font-light",
        },
        pvpText: {
          color: fields.layout === "dark" ? "white" : "grey7",
          kind: "span",
          fontType: "font-light",
          align: "left",
          size: "title04",
          text: item.fields.unidad,
        },
        button: {
          label: item.fields.butonText,
          color: fields.layout === "dark" ? "white_reverse" : "blue",
          size: {
            h: "small",
            w: "liquid",
          },
          labelSize: "small",
          font: "regular",
          taggingInfo: {
            componentContent: "interes",
            componentName: "categories",
            componentProduct: item.fields.title,
            componentPerso: "",
            componentVariation: fields.tipoEmpresa || "all",
          },
        },
        flyout: {
          title: item.fields.MODULO_FLYOUT_CON_TABS[0].fields.title,
          textPrice: item.fields.textPrice,
          price: {
            amount: fixPVP(item.fields.pvp),
            unity: item.fields.unidad,
            color: "white",
            size: "emp-18",
            decoration: "none",
            withSpace: false,
            fontType: "font-regular",
          },
          pvpText: {
            color: "white",
            kind: "span",
            fontType: "font-regular",
            align: "left",
            size: "title06",
            text: item.fields.unidad,
          },
          data: item.fields.MODULO_FLYOUT_CON_TABS[0].fields.listadoTabFlyOut,
          tabs: item.fields.MODULO_FLYOUT_CON_TABS[0].fields.listadoTabFlyOut.reduce(
            (arr, itemTab) => {
              const { tab } = itemTab.fields;
              arr = [...arr, tab];
              return arr;
            },
            []
          ),
          C2CEmpProps: [
            {
              porcentaje: "88",
              destino: "Gevico",
              tes: "SI",
              tipoTes: "FONGEV_B",
            },
            {
              porcentaje: "12",
              destino: "InsideSales",
              tes: "SI",
              tipoTes: "FONINS_B",
            },
          ],
        },
      };
    });
    if (Object.keys(items).length > 0) {
      newFields.components.categories = items;
      return newFields;
    }
    return null;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloCategorias",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de SelectorEmpleados
 * @returns
 * Devuelve la informacion para el módulo de SelectorEmpleados
 */
export const moduloSelectorEmpleados = (fields) => {
  try {
    const newFields = {
      components: [],
      selectEmpresa: fields.fields.empresa,
      selectAutonomo: fields.fields.autonomo,
      selectPyme: fields.fields.pyme,
    };
    const components = {
      "TextInfo-1": {
        text: fields.fields.h2Title,
        align: "center",
        color: "white",
        kind: "paragraph",
        size: "title02",
        fontType: "font-light",
        segment: "emp",
      },
      "TextInfo-2": {
        text: fields.fields.subTitle,
        align: "center",
        color: "white",
        kind: "paragraph",
        size: "title05",
        fontType: "font-light",
        segment: "emp",
      },
    };
    newFields.components = components;

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloSelectorEmpleados",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de CircleList
 * @returns
 * Devuelve la informacion para el módulo de CircleList
 */
export const moduloCircleList = (fields) => {
  try {
    const newFields = {
      heading: {
        color: "white",
        kind: "heading",
        level: 2,
        size: "title01",
        fontType: "font-regular",
        align: "center",
        text: fields.fields.title || "",
        segment: "emp",
      },
    };

    const listItems = fields.fields.MODULO_ICONO_TITULO_DESCRIPCION.reduce(
      (arr, item) => {
        const items = {
          number: {
            text: item.fields.icon || "",
            color: "blue",
            kind: "paragraph",
            size: "title045",
            fontType: "font-regular",
            align: "center",
            segment: "emp",
          },
          title: {
            text: item.fields.title || "",
            color: "white",
            kind: "heading",
            level: 3,
            size: "title04",
            fontType: "font-regular",
            segment: "emp",
          },
          description: {
            text: item.fields.description || "",
            color: "white",
            kind: "paragraph",
            size: "caption01",
            fontType: "font-regular",
            segment: "emp",
          },
        };
        arr = [...arr, items];
        return arr;
      },
      []
    );

    newFields.list = listItems;

    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloCircleList",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};

/**
 * Funcion que normaliza la información del EP para el pintado en el módulo
 * @param {*} fields Información del módulo de ClickBoxText
 * @returns
 * Devuelve la informacion para el módulo de ClickBoxText
 */
export const moduloClickBoxText = (fields) => {
  try {
    const newFields = {
      components: {
        "BgImage-1": {
          bgColor: "black",
          div2Fit: "full",
          size: "cover",
          alt: fields.fields.alt || "Ofertas para empresas",
          shadeLimit: false,
          picDesktop: {
            position: "center",
            size: "cover",
            src:
              (fields.fields.imgDesktop &&
                `https://www.movistar.es${fields.fields.imgDesktop}`) ||
              "",
          },
          picTablet: {
            position: "top",
            size: "cover",
            src:
              (fields.fields.imgDesktop &&
                `https://www.movistar.es${fields.fields.imgDesktop}`) ||
              "",
          },
          picMobile: {
            position: "center",
            size: "cover",
            src:
              (fields.fields.imgMobile &&
                `https://www.movistar.es${fields.fields.imgMobile}`) ||
              "",
          },
        },
        title: {
          align: "center",
          color: "white",
          kind: "span",
          size: "title05",
          fontType: "font-regular",
          text: fields.fields.title || "",
          segment: "emp",
          tabletProps: {
            size: "title03",
            align: "center",
            fontType: "font-regular",
          },
          desktopProps: {
            align: "left",
            size: "title03",
          },
        },
        descripcion: {
          align: "center",
          kind: "paragraph",
          color: "white",
          fontType: "font-regular",
          size: "title06",
          segment: "emp",
          text: fields.fields.description || "",
          tabletProps: {
            size: "title05",
            align: "center",
          },
          desktopProps: {
            size: "title05",
            align: "left",
          },
        },
        button: {
          label: fields.fields.buttonText || "",
          buttonType: "button",
          color: "white_blue",
          link:
            (fields.fields.urlBotom &&
              `https://www.movistar.es${fields.fields.urlBotom}`) ||
            "",
          size: {
            h: "large",
            w: "full",
          },
          labelSize: "medium",
          font: "regular",
          border: "no-border-radius",
          tabletProps: {
            size: {
              h: "large",
              w: "double",
            },
          },
          segment: "emp",
        },
      },
    };
    return newFields;
  } catch (error) {
    const context = createSondaContext(sondaContextTitle);
    const sonda = new Sonda({
      processName: "moduloClickBoxText",
      context,
      filePath: BenefitsFilePath,
    });
    sonda.errorMessage({ error });
    return null;
  }
};
